(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.overlayTicking = false;
      this.overlayState = null;
      this.overlayBuffer = 14;
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.overlayEnabled = this.hasAttribute('data-overlay');
      this.overlayTarget = null;
      this.resizeObserver = null;

      this.setHeaderHeight();

      this.onMatchMediaChange = this.setHeaderHeight.bind(this);
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.mobileMedia = window.matchMedia('(max-width: 990px)');
      this.mobileMedia.addEventListener('change', this.onMatchMediaChange);
      window.addEventListener('resize', this.onMatchMediaChange);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      if (this.overlayEnabled) {
        const targetSelector = this.getAttribute('data-overlay-target') || 'main .shopify-section:first-child, .shopify-section:first-child';

        try {
          this.overlayTarget = document.querySelector(targetSelector);
        } catch (e) {
          this.overlayTarget = document.querySelector('main .shopify-section:first-child') || document.querySelector('.shopify-section:first-child');
        }

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => {
            this.setHeaderHeight();
          });

          if (this.header) this.resizeObserver.observe(this.header);
          if (this.overlayTarget) this.resizeObserver.observe(this.overlayTarget);
        }
      }

      this.createObserver();
      this.updateOverlayState(true);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onMatchMediaChange);
      this.mobileMedia.removeEventListener('change', this.onMatchMediaChange);
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      this.updateOverlayState(true);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, observerRef) => {
        this.headerBounds = entries[0].intersectionRect;
        observerRef.disconnect();
      });
      observer.observe(this.header);
    }

    getOverlayThreshold() {
      if (!this.overlayTarget || !this.header) return 0;

      const targetRect = this.overlayTarget.getBoundingClientRect();
      const targetTop = targetRect.top + window.pageYOffset;
      const targetHeight = this.overlayTarget.offsetHeight || targetRect.height || 0;
      const headerHeight = this.header.offsetHeight || 0;

      return Math.max(0, Math.round(targetTop + targetHeight - headerHeight));
    }

    scheduleOverlayUpdate() {
      if (!this.overlayEnabled || !this.overlayTarget || this.overlayTicking) return;

      this.overlayTicking = true;
      requestAnimationFrame(() => {
        this.overlayTicking = false;
        this.updateOverlayState();
      });
    }

    updateOverlayState(force = false) {
      if (!this.overlayEnabled || !this.overlayTarget) return;

      const drawerOpen = this.querySelector('header-drawer details[open]');
      if (drawerOpen) {
        this.classList.remove('overlay-active');
        this.overlayState = false;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      const threshold = this.getOverlayThreshold();
      let nextState = this.overlayState;

      if (force || nextState === null) {
        nextState = scrollTop <= threshold;
      } else if (scrollTop <= threshold - this.overlayBuffer) {
        nextState = true;
      } else if (scrollTop >= threshold + this.overlayBuffer) {
        nextState = false;
      }

      if (force || nextState !== this.overlayState) {
        this.overlayState = nextState;
        this.classList.toggle('overlay-active', nextState);
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const mobileDrawerOpen = this.querySelector('header-drawer details[open]');

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (!mobileDrawerOpen) {
        this.scheduleOverlayUpdate();
      }

      if (mobileDrawerOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(() => this.hide());
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(() => this.reveal());
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(() => this.hide());
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(() => this.reset());
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.updateOverlayState(true);
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
